import React, { useCallback, useEffect, useState } from "react";
import Information from "../../common/information";
import { useDispatch, useSelector } from "react-redux";
import { editAboutUs, getAboutUs } from "../../redux/services/informationSlice";
import { toast } from "react-toastify";

const AboutUs = () => {
  const dispatch = useDispatch();
  const [editorContent, setEditorContent] = useState("");
  const [selectedType, setSelectedType] = useState("course");

  const aboutUsData = useSelector((state) => state?.information?.aboutUs);

  const handleEditorChange = (newContent) => {
    setEditorContent(newContent);
  };
  const getAboutUsData = useCallback(
    async (type) => {
      try {
        await dispatch(getAboutUs(type));
      } catch (error) {}
    },
    [dispatch]
  );

  useEffect(() => {
    getAboutUsData(selectedType);
  }, [getAboutUsData, selectedType]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await dispatch(editAboutUs({ aboutUs: editorContent, type: selectedType }));
      if (response) {
        toast.success(response?.payload?.message, {
          autoClose: 2000,
          pauseOnHover: false,
        });
        getAboutUsData(selectedType);
      }
    } catch (error) {}
  };
  useEffect(() => {
    if (aboutUsData) {
      setEditorContent(aboutUsData?.aboutUs);
    }
  }, [aboutUsData]);
  // const handleExportPDF = () => {
  //   generatePDF(editorContent, "AboutUs.pdf");
  // };
  return (
    <>
      <Information
        title="About Us"
        handleSubmit={handleSubmit}
        editorContent={editorContent}
        handleEditorChange={handleEditorChange}
        selectedType={selectedType}
        setSelectedType={setSelectedType}
        // handleExportPDF={handleExportPDF}
      />
    </>
  );
};

export default AboutUs;
